import Link from 'next/link';

import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { SectionHeader } from '@/src/components/molecules';
import { CardJobMinimal } from '@/src/components/organisms';

const Jobs = props => {
  const { data, className, ...rest } = props;

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  const { results = [] } = data || {};

  return (
    <div className={className} {...rest}>
      <SectionHeader
        title="Vagas abertas"
        subtitle="Acompanhe as vagas atualmente abertas e que estamos recebendo candidatos para serem escolhidos."
        subtitleColor="textPrimary"
        ctaGroup={[
          <Link href="/about" passHref key="aboutUsCta">
            <Button
              color="primary"
              size="large"
              variant="contained"
              component="a"
              aria-label="Sobre nós">
              Sobre nós
            </Button>
          </Link>,
        ]}
        data-aos="fade-up"
      />
      <Grid container spacing={isMd ? 4 : 2}>
        {!results.length && (
          <Grid item xs={12}>
            <Typography color="textSecondary" align="center">
              Nenhuma vaga aberta no momento.
            </Typography>
          </Grid>
        )}
        {results.map((item, index) => (
          <Grid item xs={12} key={index.toString()}>
            <CardJobMinimal
              title={item.data.title}
              subtitle={`${item.data.location} / ${item.data.type}`}
              to={`/careers/job/${item.uid}`}
              showArrow
              titleProps={{
                variant: 'h6',
                component: 'div',
              }}
              subtitleProps={{
                variant: 'subtitle1',
              }}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

Jobs.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.object.isRequired,
};

export default Jobs;
